import { render, staticRenderFns } from "./profileTabs.vue?vue&type=template&id=583efea6&scoped=true"
import script from "./profileTabs.vue?vue&type=script&lang=js"
export * from "./profileTabs.vue?vue&type=script&lang=js"
import style0 from "./profileTabs.vue?vue&type=style&index=0&id=583efea6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "583efea6",
  null
  
)

export default component.exports